import { render } from "./HeroiconsOutlineMenuAlt4.vue?vue&type=template&id=38f87317"
const script = {}

import exportComponent from "/home/roland/vscode/diablo/newsroom/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineMenuAlt4.vue"]])

export default __exports__